module.exports = __webpack_public_path__ + "static/img/avatar.cf5b1169.png";